<template>
  <div class="animated fadeIn">
    <b-card header="Update Margin">
      <b-row class="mb-2">
        <b-col md="6">
          <table class="table table-bordered">
            <tbody>
              <tr>
                <th scope="row">Buy Incentive Type</th>
                <td>{{ partner.buy_incentive_type }}</td>
              </tr>
              <tr>
                <th scope="row">Basic Buy Price</th>
                <td>{{ partner.basic_buy_price | toRupiah }}</td>
              </tr>
              <tr>
                <th scope="row">Partner Buy Price</th>
                <td :class="localState.buyMarginClass">{{ partner.partner_buy_price | toRupiah }}</td>
              </tr>
            </tbody>
          </table>
        </b-col>
        <b-col md="6">
          <table class="table table-bordered">
            <tbody>
              <tr>
                <th scope="row">Sell Incentive Type</th>
                <td>{{ partner.sell_incentive_type }}</td>
              </tr>
              <tr>
                <th scope="row">Basic Sell Price</th>
                <td>{{ partner.basic_sell_price | toRupiah }}</td>
              </tr>
              <tr>
                <th scope="row">Partner Sell Price</th>
                <td :class="localState.sellMarginClass">{{ partner.partner_sell_price | toRupiah }}</td>
              </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <label for="name">Buy Margin</label>
          <b-input-group class="mb-3">
            <b-form-input v-model="input.buyMargin" :disabled="localState.isDisableBuyMargin" name="buy_margin" type="number" min="0" max="99" />
            <b-input-group-append><b-input-group-text>%</b-input-group-text></b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col md="6">
          <label for="name">Sell Margin</label>
          <b-input-group class="mb-3">
            <b-form-input v-model="input.sellMargin" :disabled="localState.isDisableSellMargin" name="sell_margin" type="number" min="0" max="99" />
            <b-input-group-append><b-input-group-text>%</b-input-group-text></b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <b-button :disabled="storeState.isProcessing || (localState.isDisableBuyMargin && localState.isDisableSellMargin)" variant="primary" class="px-4 mt-2" @click="handleUpdateMargin">Save</b-button>
    </b-card>
  </div>
</template>

<script>
import { store } from '@/shared/store'
import { getPartnerInfo, marginSimulation, updateMargin, handleError } from '@/services/metal'
import { toRupiah, debounce } from '@/shared/utils'
export default {
  name: 'UpdateMargin',

  filters: {
    toRupiah: function(val) {
      return toRupiah(val)
    }
  }, // filters

  data() {
    return {
      partner: null,
      input: {
        buyMargin: 0,
        sellMargin: 0,
      },
      localState: {
        canSimulate: false,
        isDisableBuyMargin: false,
        isDisableSellMargin: false,
        buyMarginClass: '',
        sellMarginClass: '',
      },
      storeState: store.state,
    }
  }, // data

  watch: {
    'input.buyMargin': debounce(function(){
      if (this.localState.canSimulate){
        this.simulateMargin()
      }
    }, 1000, true),
    'input.sellMargin': debounce(function(){
      if (this.localState.canSimulate){
        this.simulateMargin()
      }
    }, 1000, true)
  }, // watch

  created() {
    store.setIsInitLoading(true)
    store.setIsProcessing(true)

    getPartnerInfo()
      .then(response => {
        this.partner = response.data.data

        this.input.buyMargin = response.data.data.buy_margin
        this.input.sellMargin = response.data.data.sell_margin

        if (this.partner.buy_incentive_type != "NETT_PRICE"){
          this.localState.isDisableBuyMargin = true
        }

        if (this.partner.sell_incentive_type != "NETT_PRICE"){
          this.localState.isDisableSellMargin = true
        }

        store.setIsInitLoading(false)

        setTimeout(() => {
          this.localState.canSimulate = true
        }, 1100)
      })
      .catch(error => {
        handleError(error)
      })
      .then(() => {
        store.clearProcessing()
      })
  }, // created

  methods: {
    simulateMargin() {
      store.setIsChildLoading(true)

      marginSimulation(this.input.buyMargin, this.input.sellMargin)
        .then(response => {
          this.partner.partner_buy_price = response.data.data.raised_buy
          this.partner.partner_sell_price = response.data.data.raised_sell

          if (this.input.buyMargin != this.partner.buy_margin) {
            this.localState.buyMarginClass = 'text-success'
          } else {
            this.localState.buyMarginClass = ''
          }

          if (this.input.sellMargin != this.partner.sell_margin) {
            this.localState.sellMarginClass = 'text-success'
          } else {
            this.localState.sellMarginClass = ''
          }

          store.hideAlert()
        })
        .catch(error => {
          handleError(error)
        })
        .then(() => {
          store.clearProcessing()
        })
    },

    handleUpdateMargin() {
      if (!store.isProcessing()){
        store.setIsProcessing(true)
        store.setIsChildLoading(true)

        updateMargin(this.input.buyMargin, this.input.sellMargin)
          .then(() => {
            this.partner.buy_margin = this.input.buyMargin
            this.partner.sell_margin = this.input.sellMargin
            this.localState.buyMarginClass = ''
            this.localState.sellMarginClass = ''

            window.scrollTo(0,0)
            store.showAlert('Margin updated successfully', 'success')
          })
          .catch(error => {
            handleError(error)
          })
          .then(() => {
            store.clearProcessing()
          })
      }
    },
  }, // methods
}
</script>
